PJQ.views.directcosts.DirectCostDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'Click "Add Direct Cost" to create a new Direct Cost',
            zeroRecords: "No Direct Costs matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.DIRECTCOSTS, 'data-table-header-direct-costs')
        },
        toggleRowClass: '.dc-toggle-row'
    },
    events: {},
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
    },
    getDefaultFilter: function () {
        let defaultFilter = {};
        defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER] = this.options.userSettings.get('defaultTypeFilter');
        defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER] = _.map(defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER], function (type) {
            return type * -1;
        });
        defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER] = _.size(this.options.statusIds) > 0 ? this.options.statusIds : this.options.userSettings.get('defaultStatusFilter');

        return defaultFilter;
    },
    getFilterValues: function () {
        let typeFilter = this.getFilter(PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER),
            statusFilter = this.getFilter(PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER);
        return {
            search: this.$('.datatable-search').val(),
            typeFilter: typeFilter.join(','),
            statusFilter: statusFilter.join(',')
        };
    },
    afterHeaderRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.direct-cost-filter'),
            defaultValue: this.getDefaultFilter(),
            isGrouped: true,
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                value.directCostStatusFilter = value.directCostStatusFilter ? value.directCostStatusFilter : [];
                value.directCostTypeFilter = value.directCostTypeFilter ? value.directCostTypeFilter : [];
                _.each(value, _.bind(function (value, filter) {
                    if (filter === PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER)
                        value = _.map(value, function (type) {
                            return type * -1;
                        });
                    this.setFilter(filter, value);
                }, this));
            }, this)
        });

        let defaultFilters = this.getDefaultFilter();
        this.setFilter(PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER, defaultFilters[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER]);
        this.setFilter(PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER, defaultFilters[PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER]);
    },
    getFilterData: function () {
        let typeFilter = this.getFilter(PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER),
            statusFilter = this.getFilter(PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER),
            result = null, draft = 0, total = 0;
        if (_.size(typeFilter) === 0 && _.size(statusFilter) === 0) {
            result = this.options.data;
        } else {
            result = _.filter(this.options.data, function (row) {
                return (_.size(typeFilter) === 0 || _.contains(typeFilter, row.get('type'))) && (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
            });
        }

        _.each(result, function (directCost) {
            if (directCost.get('statusId') === PJQ.constants.directcosts.directCostStatus.DRAFT)
                draft += directCost.get('amount') ? directCost.get('amount') : 0;
            else
                total += directCost.get('amount') ? directCost.get('amount') : 0;
        });

        this.options.directCostView.renderTotals(draft, total);

        return result;
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['createdOn', 'type', 'status', 'description', 'vendor.companyName', 'vendor.contactName', 'reportedBy.companyName', 'reportedBy.contactName', 'terms', 'appliedOn', 'receivedOn', 'paidOn', 'amount'];

        if (this.options.customFields) {
            _.each(this.options.customFields.models, _.bind(function (customField) {
                includeColumns.push('fieldValue' + customField.get('fieldNumber'));
            }, this));
        }

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;

            columns.push({
                "columnData": "childData",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": (data, type, row) => {
                    if(!this.options.isAdmin){
                        return "";
                    }

                    return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "10%",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'type':
                    columns.push({
                        "columnData": "type",
                        "data": "attributes.type",
                        "title": "Type",
                        "width": "110px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.directcosts.directCostTypeNames[row.get('type')]
                        }, this)
                    });
                    break;
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.directcosts.directCostStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'terms':
                    columns.push({
                        "columnData": "terms",
                        "data": "attributes.terms",
                        "title": "Terms"
                    });
                    break;
                case 'appliedOn':
                    columns.push({
                        "columnData": "appliedOn",
                        "data": "attributes.appliedOn",
                        "title": 'Applied',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return row.get('appliedOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('appliedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
                        }, this)
                    });
                    break;
                case 'receivedOn':
                    columns.push({
                        "columnData": "receivedOn",
                        "data": "attributes.receivedOn",
                        "title": 'Received',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return row.get('receivedOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('receivedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
                        }, this)
                    });
                    break;
                case 'paidOn':
                    columns.push({
                        "columnData": "paidOn",
                        "data": "attributes.paidOn",
                        "title": 'Paid',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return row.get('paidOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('paidOn')), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
                        }, this)
                    });
                    break;
                case 'vendor.companyName':
                    columns.push({
                        "columnData": "vendor.companyName",
                        "title": "Vendor",
                        "render": _.bind(function (data, type, row) {
                            return row.get('vendor') ? row.get('vendor').companyName : 'N/A';
                        }, this)
                    });
                    break;
                case 'vendor.contactName':
                    columns.push({
                        "columnData": "vendor.contactName",
                        "title": "Vendor Contact",
                        "render": _.bind(function (data, type, row) {
                            return row.get('vendor') ? row.get('vendor').contactName : 'N/A';
                        }, this)
                    });
                    break;
                case 'reportedBy.companyName':
                    columns.push({
                        "columnData": "reportedBy.companyName",
                        "title": "Reported by Company",
                        "render": _.bind(function (data, type, row) {
                            return row.get('reportedBy') ? row.get('reportedBy').companyName : 'N/A';
                        }, this)
                    });
                    break;
                case 'reportedBy.contactName':
                    columns.push({
                        "columnData": "reportedBy.contactName",
                        "title": "Reported by Contact",
                        "render": _.bind(function (data, type, row) {
                            return row.get('reportedBy') ? row.get('reportedBy').contactName : 'N/A';
                        }, this)
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue')) {
                        _.each(this.options.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "className": [PJQ.constants.commitments.customFieldType.INTEGER, PJQ.constants.commitments.customFieldType.MONEY, PJQ.constants.commitments.customFieldType.PERCENT].indexOf(customField.get('fieldTypeId')) !== -1 ? "text-align-right" : "",
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (!fieldValue)
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)), 2, false) + '%' : '';
                                                }
                                                break;
                                        }

                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-direct-cost ml-1" title="View direct cost"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    getRowChildTable: function (childOpts) {
        childOpts.costTypes = this.options.costTypes;
        childOpts.unitsOfMeasure = this.options.unitsOfMeasure;
        childOpts.groups = this.options.groups;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.directcosts.DirectCostLineItemDataTable(childOpts);
    },
    getRowChildData: function (row) {
        return new PJQ.collections.directcosts.LineItems(null, {
            projectId: row.data().get('projectId'),
            directCostId: row.data().get('id')
        });
    }
});

PJQ.views.directcosts.DirectCostLineItemDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            zeroRecords: "No Line Items Added"
        },
        canEdit: false,
        onEditLineItem: _.noop,
        onDeleteLineItem: _.noop
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns;
        if (this.options.parentData && this.options.parentData.get('accountingMethod') === PJQ.constants.budget.accountingMethod.AMOUNT)
            includeColumns = ['group', 'costTypeDescription', 'description', 'amount', 'billedToDate', 'amountRemaining'];
        else
            includeColumns = ['group', 'costTypeDescription', 'description', 'quantity', 'unitOfMeasure', 'unitPrice', 'amount', 'billedToDate', 'amountRemaining'];

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "orderable": false,
                        "title": "Description"

                    });
                    break;
                case 'quantity':
                    columns.push({
                        "columnData": "quantity",
                        "data": "attributes.quantity",
                        "orderable": false,
                        "width": "8%",
                        "title": "Units",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatDecimal(row.get('quantity'), 2);
                        }, this)
                    });
                    break;
                case 'unitOfMeasure':
                    columns.push({
                        "columnData": "unitOfMeasure",
                        "data": "attributes.unitId",
                        "orderable": false,
                        "title": "Unit",
                        "width": "5%",
                        "render": _.bind(function (data, type, row) {
                            let unitOfMeasure = this.options.unitsOfMeasure.get(row.get('unitId'));
                            return unitOfMeasure ? unitOfMeasure.get('code') : '';
                        }, this)
                    });
                    break;
                case 'unitPrice':
                    columns.push({
                        "columnData": "unitPrice",
                        "data": "attributes.unitPrice",
                        "orderable": false,
                        "width": "10%",
                        "title": "Unit Price",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('unitPrice'));
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "orderable": false,
                        "width": "10%",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'group':
                    columns.push({
                        "columnData": "group",
                        "orderable": false,
                        "title": "Cost Code",
                        "render": _.bind(function (data, type, row) {
                            let group = this.options.groups.get(row.get('groupId'));
                            return group ? group.get('groupName') : '';
                        }, this)
                    });
                    break;
                case 'costType':
                    columns.push({
                        "columnData": "costType",
                        "orderable": false,
                        "title": "Type Code",
                        "titleSettings": "Cost Type",
                        "width": "8%",
                        "render": _.bind(function (data, type, row) {
                            let costType = this.options.costTypes.get(row.get('costTypeId'));
                            return costType ? costType.get('code') : '';
                        }, this)
                    });
                    break;
                case 'costTypeDescription':
                    columns.push({
                        "columnData": "costTypeDescription",
                        "orderable": false,
                        "title": "Type",
                        "render": _.bind(function (data, type, row) {
                            let costType = this.options.costTypes.get(row.get('costTypeId'));
                            return costType ? costType.get('name') : '';
                        }, this)
                    });
                    break;
            }
        }, this));

        return columns;
    }
});
